module.exports = __webpack_public_path__ + "static/logo-0124936f7c907c06ba91360d66db3bef.png";